import React from "react";
import { Button, Modal, Fade, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import styles from "Styles.module.scss";

export default function PlanesYPagos(props) {
	return <>
		<Modal open={props.open} onClose={props.onClose} className={styles.modal}>
			<Fade in={props.open}>
				<div className={styles.paper} style={{position:"relative", ...(props.fullWidth ? {width:"90%"} :{})}}>
					<div style={{position:"absolute",top:"0",right:"0"}}>
						<IconButton onClick={props.onClickClose}><CloseIcon /></IconButton>
					</div>
					<div style={{textAlign:"center", fontSize:"1.5em",fontWeight:"bold",marginBottom:"10px"}}>{props.title}</div>

					{props.children}
					{/* <div style={{textAlign:"right"}}>
						<Button variant="contained" color="secondary" onClick={props.onClickClose}>Cerrar</Button>
					</div> */}
				</div>
			</Fade>
		</Modal>
	</>;
}
/*
open
onClose
fullWidth
onClickClose
title
*/
